import Affix from './affix';
import Alert from './alert';
import Anchor from './anchor';
import AutoComplete from './auto-complete';
import Avatar from './avatar';
import BackTop from './back-top';
import Badge from './badge';
import Breadcrumb from './breadcrumb';
import Button from './button';
import Calendar from './calendar';
import Card from './card';
import Carousel from './carousel';
import Cascader from './cascader';
import Checkbox from './checkbox';
import Col from './col';
import Collapse from './collapse';
import Comment from './comment';
import ConfigProvider from './config-provider';
import ContextMenu from './context-menu';
import CheckItem from './check-item';
import DatePicker from './date-picker';
import Divider from './divider';
import Drawer from './drawer';
import Dropdown from './dropdown';
import Descriptions from './descriptions';
import DynamicAttribute from './dynamic-attribute';
import Empty from './empty';
import Form from './form';
import SimpleForm from './simple-form';
import Icon from './icon';
import ImageViewer from './image-viewer';
import Input from './input';
import InputNumber from './input-number';
import Layout from './layout';
import List from './list';
import LocaleProvider from './locale-provider';
import Mention from './mention';
import Menu from './menu';
import message from './message';
import Modal from './modal';
import NativeTable from './native-table';
import notification from './notification';
import Pagination from './pagination';
import Popconfirm from './popconfirm';
import PopEdit from './pop-edit';
import Popover from './popover';
import Progress from './progress';
import Radio from './radio';
import Result from './result';
import Rate from './rate';
import RichEditor from './rich-editor';
import ContentUtils from './content-utils';
import Row from './row';
import SearchInput from './search-input';
import Select from './select';
import Skeleton from './skeleton';
import Slider from './slider';
import SliderDate from './slider-date';
import Spin from './spin';
import Steps from './steps';
import Switch from './switch';
import Table from './table';
import TableSelect from './table-select';
import TableEdit from './table-edit'
import Tabs from './tabs';
import Tag from './tag';
import Timeline from './timeline';
import TimePicker from './time-picker';
import Tooltip from './tooltip';
import Transfer from './transfer';
import Tree from './tree';
import TreeSelect from './tree-select';
import Upload from './upload';
import WaterMark from './water-mark';
import PagePoint from './page-point';
import BigNumber from './bignumber';
import VideoPlayer from './video-player';
import HorizontalSelect from './horizontal-select';
import IconPicker from './icon-picker';
import IconFont from './icon-font';

export {
    Affix,
    Alert,
    Anchor,
    AutoComplete,
    Avatar,
    BackTop,
    Badge,
    Breadcrumb,
    Button,
    BigNumber,
    Calendar,
    Card,
    Carousel,
    Cascader,
    Checkbox,
    CheckItem,
    Col,
    Collapse,
    Comment,
    ConfigProvider,
    ContextMenu,
    DatePicker,
    Descriptions,
    Divider,
    Drawer,
    Dropdown,
    DynamicAttribute,
    Empty,
    Form,
    SimpleForm,
    Icon,
    ImageViewer,
    Input,
    InputNumber,
    Layout,
    List,
    LocaleProvider,
    Mention,
    Menu,
    message,
    Modal,
    NativeTable,
    notification,
    Pagination,
    Popconfirm,
    PopEdit,
    Popover,
    Progress,
    Radio,
    Rate,
    RichEditor,
    ContentUtils,
    Result,
    Row,
    SearchInput,
    Select,
    Skeleton,
    Slider,
    SliderDate,
    Spin,
    Steps,
    Switch,
    Table,
    TableSelect,
    TableEdit,
    Tabs,
    Tag,
    Timeline,
    TimePicker,
    Tooltip,
    Transfer,
    Tree,
    TreeSelect,
    Upload,
    WaterMark,
    PagePoint,
    VideoPlayer,
    HorizontalSelect,
    IconPicker,
    IconFont
}


// WEBPACK FOOTER //
// ./src/components/index.tsx